import React, {Component} from 'react';
import { Card, CardImg, 
    CardTitle ,CardBody,CardText,Breadcrumb,BreadcrumbItem,Button,Modal, ModalHeader, ModalBody, Row, Label} from 'reactstrap';
import {Link} from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Loading } from './LoadingComponent';
import {FadeTransform,Fade, Stagger} from 'react-animation-components';



	
       function RenderComments({comments,addComment, dishId}){
			if(comments ==null)
				
					return(<div></div>)
				
			else{
				 
					const comm= comments.map((comment)=>{
		 return (
			 <Fade in>
			 <li key={comment.id} >
			 <p>{comment.comment}</p>
				 <p>-- {comment.author},
                    &nbsp;
                    {new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: '2-digit'
                        }).format(new Date(comment.date))}
               </p>
			 </li>
			 </Fade>
		 )
						
		 
	 })
				
				 return(
			<div className='col-12 col-md-5 m-1'>
                <h4> Comments </h4>
                <ul className='list-unstyled'>
					<Stagger in>
                    {comm}
					</Stagger>
				</ul>
						  <CommentForm  dishId={dishId} addComment={addComment}/>
            </div>
				 )
				
				
			}
				
			
		};

	function RenderDish({dish}){
		
		if( dish!=null)
			
				return(<div className="col-12 col-md-5 m-1">
					<FadeTransform
                in
                transformProps={{
                    exitTransform: 'scale(0.5) translateY(-50%)' }}>	
				
					<Card>
                    <CardImg top src={dish.image} alt={dish.name} />
                    <CardBody>
                      <CardTitle>{dish.name}</CardTitle>
                      <CardText>{dish.description}</CardText>
                    </CardBody>
                </Card>
						</FadeTransform>
					</div>);
			
		else
			
			return(<div></div>);
			
	}

const DishDetail=(props)=> {
	 
	if (props.isLoading) {
            return(
                <div className="container">
                    <div className="row">            
                        <Loading />
                    </div>
                </div>
            );
        }
        else if (props.errMess) {
            return(
                <div className="container">
                    <div className="row">            
                        <h4>{props.errMess}</h4>
                    </div>
                </div>
            );
        }
	
	else if(props.dish!=null)
		{
		
			return(
				<div className="container">
					 <div className="row">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to="/menu">Menu</Link></BreadcrumbItem>
                        <BreadcrumbItem active>{props.dish.name}</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3>{props.dish.name}</h3>
                        <hr />
                    </div>                
                </div>
					
				<div className="row">
				< RenderDish dish= {props.dish} />
				< RenderComments comments= {props.comments}   addComment={props.addComment}  dishId={props.dish.id}
                   />

				</div>
				</div>)
		}
};

export default DishDetail;

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => val && (val.length >= len);

export class CommentForm extends Component
{
	constructor(props){
		super(props);
		this.state={
			 isModalOpen: false
		}
		this.toggleModal = this.toggleModal.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		}
	toggleModal() {
        this.setState({
          isModalOpen: !this.state.isModalOpen
        });
      }
	handleSubmit(values) {
        this.toggleModal();
        this.props.addComment(this.props.dishId, values.rating, values.author, values.comment);

    }
      render(){
		  return(
			    <div>
				   <Button outline onClick={this.toggleModal}>
                    <span className="fa fa-pencil fa-lg"> Submit comment</span>
                </Button>
				  <div className="row row-content">
					  <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit comment</ModalHeader>
                    <ModalBody>
						<div className="col-12 col-md-9">
                         <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
						   <Label htmlFor="rating" >Rating</Label>
							
							       <Row className="form-group">
                                        
                                            <Control.select model=".rating" name="rating" className="form-control" >
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option>
                                            </Control.select>
                                    
							       </Row>
							 
						   <Row className="form-group">
                                <Label htmlFor="author">Your Name</Label>
                            
                                    <Control.text model=".author" id="author" name="author"
                                        placeholder="Your Name"
                                        className="form-control"
										validators={{ required, minLength: minLength(3), maxLength: maxLength(15)}}/>
							   
								<Errors className="text-danger"
                                        model=".author"
                                        show="touched"
                                        messages={{
                                            required: ' Required ',
                                            minLength: 'Must be greater than 2 character',
                                            maxLength: 'Must be 15 character or less',
										    
                                        }}/>
                            </Row>
							  <Row className="form-group">
                                <Label htmlFor="comment" >Comment</Label>
                               
                                    <Control.textarea model=".comment" id="comment" name="comment" rows="6" className="form-control"
										validators={{ required}}/>
                               
								<Errors className="text-danger"
                                        model=".comment"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            
										    
                                        }}/>
                            </Row>
						    
						   <Button type="submit" value="submit" color="primary">Submit</Button>
							</LocalForm>
						</div>
                    </ModalBody>
						 
                </Modal>
					  
					  
				  </div>
			  </div>
		  )
	  }

    
}